import { useEffect, useState } from 'react';
import React from 'react';

import { Spin, Space, Button, message, Form, DatePicker, Input } from 'antd';
import dayjs from 'dayjs';

import sessionManager, { eVariableType } from '../../../SessionManager';
import { isValidDateValue } from '../../../Utility';
import api from '../../../api';
import stringres from '../../../translations/stringres';
import CmbGenerico from '../../Combos/CmbGenerico';

export default function OpportunitaAttivitaAddEdit(props) {
    const { confirm } = props;
    const { AttivitaOpportunita } = props;
    const { idOpportunita } = props;

    const { TextArea } = Input;
    const [form] = Form.useForm();

    const [isLoadingSave, setIsLoadingSave] = useState(false);

    useEffect(() => {
        async function loadData() {
            if (isNaN(AttivitaOpportunita?.idAttivitaOpportunita)) return;

            try {
                const result = await api.get(
                    'CRM/Opportunita/Attivita?idSocieta=' +
                        sessionManager.get(eVariableType.IDSocieta) +
                        '&idAttivitaOpportunita=' +
                        AttivitaOpportunita.idAttivitaOpportunita +
                        '&idOpportunita=' +
                        idOpportunita
                );

                if (result != null && result.data != null) {
                    const data = result.data[0];
                    console.log('dati', data);
                    form.setFieldValue('idAttivitaOpportunita', data.idAttivitaOpportunita);
                    form.setFieldValue('note', data.note);
                    form.setFieldValue('oggetto', data.oggetto);
                    if (isValidDateValue(data.dataOraPrevista))
                        form.setFieldValue('dataOraPrevista', dayjs(data.dataOraPrevista));

                    if (isValidDateValue(data.dataOraEsecuzione))
                        form.setFieldValue('dataOraEsecuzione', dayjs(data.dataOraEsecuzione));

                    form.setFieldValue('eseguita', data.eseguita);
                    form.setFieldValue('operatoreAdd', data.operatoreAdd);
                    form.setFieldValue('idAttivitaTipo', data.idAttivitaTipo);
                }
            } catch (error) {
                message.error(error.result.data.message, 5);
            }
        }

        loadData();
    }, [props?.idAttivita, form]);

    async function Salva() {
        try {
            setIsLoadingSave(true);
            const request = {
                idAttivitaOpportunita: form.getFieldValue('idAttivitaOpportunita'),
                iDOpportunita: idOpportunita,
                idSocieta: sessionManager.get(eVariableType.IDSocieta),
                idOperatore: sessionManager.get(eVariableType.IDOperatore),
                idAttivitaTipo: form.getFieldValue('idAttivitaTipo'),
                note: form.getFieldValue('note'),
                oggetto: form.getFieldValue('oggetto'),
                dataOraPrevista: dayjs(form.getFieldValue('dataOraPrevista')),
                dataOraEsecuzione: dayjs(form.getFieldValue('dataOraEsecuzione')),
            };

            const result = await api.post('CRM/Opportunita/Attivita/Insert', request);

            if (result != null && result.data != null) {
                message.success(stringres.t('successo'));

                form.resetFields();

                confirm(true);
            } else {
                message.error(result.statusTextat);
            }
        } catch (error) {
            console.log(error);
            message.error(error.response.data.message, 5);
        } finally {
            setIsLoadingSave(false);
        }
    }

    return (
        <Spin spinning={isLoadingSave}>
            <Form form={form} onFinish={Salva}>
                <Form.Item name="oggetto" rules={[{ required: true }]}>
                    <Input rows={3} placeholder={stringres.t('oggetto')}></Input>
                </Form.Item>
                <Form.Item name="note">
                    <TextArea rows={3} placeholder={stringres.t('note')}></TextArea>
                </Form.Item>
                <Form.Item name="idAttivitaTipo" rules={[{ required: true }]}>
                    <CmbGenerico
                        value={!form ? form.getFieldValue('idAttivitaTipo') : null}
                        placeholder={stringres.t('attivitatipo')}
                        onChange={(value) => form.setFieldsValue({ idAttivitaTipo: value })}
                        queryurl="CRM/Opportunita/Attivita/Tipi"
                        insertupdateurl="CRM/Opportunita/Attivita/Tipi/InsertUpdate"
                        deleteurl="CRM/Opportunita/Attivita/Tipi/Delete"
                        campoid="idAttivitaTipo"
                        campoidSocieta="idSocieta"
                        campoDescrizione="attivitaTipo"
                    ></CmbGenerico>
                </Form.Item>
                <Form.Item>
                    <Form.Item className="Form-item-inline2componenti" name="dataOraPrevista">
                        <DatePicker placeholder={stringres.t('dataprevista')} showTime format="YYYY-MM-DD HH:mm" />
                    </Form.Item>
                    <Form.Item className="Form-item-inline2componenti" name="dataOraEsecuzione">
                        <DatePicker placeholder={stringres.t('dataesecuzione')} showTime format="YYYY-MM-DD HH:mm" />
                    </Form.Item>
                </Form.Item>
                <Form.Item style={{ textAlign: 'end', marginTop: '15px' }}>
                    <Space>
                        <Button style={{ width: '120px' }} type="primary" htmlType="submit">
                            {stringres.t('conferma')}
                        </Button>
                        <Button style={{ width: '120px' }} type="primary" onClick={() => confirm(false)}>
                            {stringres.t('annulla')}
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </Spin>
    );
}
